import { render, staticRenderFns } from "./BuffBar.vue?vue&type=template&id=96f23828&scoped=true&"
import script from "./BuffBar.vue?vue&type=script&lang=js&"
export * from "./BuffBar.vue?vue&type=script&lang=js&"
import style0 from "./BuffBar.vue?vue&type=style&index=0&id=96f23828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f23828",
  null
  
)

export default component.exports